<template lang="pug">
  .report
    PDatePicker(
      name="date"
      label="data final"
      v-model="endDate"
      format="DD/MM/YYYY"
    )
    .button
      PButton(color="success" size="md" @click="generate()" :loading="loading" :disabled="!valid") exportar arquivo

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      endDate: moment().toDate()
    }
  },
  methods: {
    async generate () {
      this.loading = true

      let result

      const params = {
        companies: [],
        employees: [],
        endDate: this.endDate
      }

      if (this.reportInfo.entity === 'companies') {
        params.companies = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'employees') {
        params.employees = this.reportInfo.entityContent.map(i => i.id)
      }

      try {
        result = await this.$API.E03.save(params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;
  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
